export const iconFontAwesomeMapsTty = (
	<i className="fa-solid fa-tty"></i>
);
